import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-152">
      <div className="max-w-4xl mx-auto" data-id="element-153">
        <div className="bg-bg-alt border border-primary/30 shadow-[0_0_30px_rgba(59,130,246,0.1)] rounded-3xl p-10 sm:p-16 text-center relative overflow-hidden" data-id="element-154">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-primary/5 blur-[50px] pointer-events-none" data-id="element-155"></div>

          <div className="w-24 h-24 mx-auto bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 rounded-full flex items-center justify-center mb-8 shadow-inner" data-id="element-156">
            <span className="text-5xl drop-shadow-[0_0_15px_rgba(59,130,246,0.5)]" data-id="element-157">
              🛡️
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl font-black text-text-main mb-6 tracking-tight" data-id="element-158">
            FÅ DIN TID TILBAGE ELLER PENGENE RETUR
          </h2>

          <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-159">
            Vi er så sikre på effektiviteten af{' '}
            <span className="text-text-main font-bold" data-id="element-160">Håndbold Klar</span>, at
            vi giver dig{' '}
            <span className="text-primary font-bold" data-id="element-161">
              7 dage til at prøve det
            </span>
            . Hvis du ikke føler, at dit arbejde som træner bliver lettere og
            mere overskueligt, refunderer vi{' '}
            <span className="text-text-main font-bold" data-id="element-162">100% af dine penge</span>
            . <span className="text-text-main font-bold" data-id="element-163">Ingen spørgsmål.</span>
          </p>
        </div>
      </div>
    </section>;
}